/* ==========================================================================
   TRCO Cart Drawer · part D of 4 — discount codes, boot, add-to-cart interception
   ========================================================================== */
(function () {
  'use strict';
  var T = window.__trco; if (!T) return;
  var CONFIG = T.CONFIG, url = T.url, formatMoney = T.formatMoney, esc = T.esc,
      sameCode = T.sameCode, postJSON = T.postJSON, Ctrl = T.Ctrl;

  /* ---- discount --------------------------------------------------------- */
  // Codes are set on the cart with /cart/update.js. The cart that comes back
  // lists every code in discount_codes[], each with `applicable: true/false`
  // (Shopify's own check: valid code, eligible items, minimums met).

  Ctrl.prototype.cartCodes = function (cart) {
    return ((cart && cart.discount_codes) || []).filter(function (d) { return d && d.code; });
  };

  // Total a code is saving: its line-level allocations plus any order-level
  // (cart-wide) application with the same title.
  Ctrl.prototype.codeSavings = function (cart, code) {
    var total = 0;
    ((cart && cart.items) || []).forEach(function (it) {
      (it.line_level_discount_allocations || []).forEach(function (a) {
        if (a && a.discount_application && sameCode(a.discount_application.title, code)) total += a.amount || 0;
      });
    });
    ((cart && cart.cart_level_discount_applications) || []).forEach(function (app) {
      if (app && sameCode(app.title, code)) total += app.total_allocated_amount || 0;
    });
    return total;
  };

  Ctrl.prototype.applyDiscount = function () {
    if (!this.discountInput) return;
    var code = (this.discountInput.value || '').trim();
    if (!code) return;
    var self = this;
    var applyBtn = this.$('[data-trco-discount-apply]');
    // Codes already working on the cart, so a rejected attempt can put them back.
    var previous = this.cartCodes(this.cart)
      .filter(function (d) { return d.applicable && !sameCode(d.code, code); })
      .map(function (d) { return d.code; });

    this._discountError = null;
    if (applyBtn) applyBtn.disabled = true;
    this.el.classList.add('is-busy');

    postJSON('cart/update.js', { discount: code })
      .then(function (cart) {
        var entry = (cart && cart.items)
          ? self.cartCodes(cart).filter(function (d) { return sameCode(d.code, code); })[0]
          : null;
        if (entry && entry.applicable) {
          self.discountInput.value = '';
          self.cart = cart;
          return self.ensureCompareData(cart);
        }
        // Not accepted: report it and restore whatever codes were working before.
        self._discountError = code;
        return postJSON('cart/update.js', { discount: previous.join(',') }).then(function (c2) {
          if (c2 && c2.items) self.cart = c2;
        });
      })
      .catch(function () { self._discountError = code; })
      .then(function () {
        if (applyBtn) applyBtn.disabled = false;
        self.el.classList.remove('is-busy');
        self.render();
      });
  };

  Ctrl.prototype.removeDiscount = function (code) {
    var self = this;
    var keep = this.cartCodes(this.cart)
      .filter(function (d) { return !sameCode(d.code, code); })
      .map(function (d) { return d.code; });
    this._discountError = null;
    this.el.classList.add('is-busy');
    postJSON('cart/update.js', { discount: keep.join(',') })
      .then(function (cart) {
        if (cart && cart.items) self.cart = cart;
        return self.ensureCompareData(self.cart);
      })
      .catch(function () {})
      .then(function () {
        self.el.classList.remove('is-busy');
        self.render();
      });
  };

  // Status lines under the discount field:
  //   ✓ VIP20 applied — you save $25.33                    (Remove)
  //   VIP20 isn't valid for the items in your cart          (Remove)  <- code on cart, items changed
  //   VIP2O isn't valid for the items in your cart                    <- attempt just rejected
  Ctrl.prototype.renderDiscount = function (cart) {
    var el = this.discountStatus;
    if (!el) return;
    var self = this;
    var copy = CONFIG.copy || {};
    var invalidText = copy.discountInvalid || "isn't valid for the items in your cart";
    var removeText = copy.discountRemove || 'Remove';
    var savedText = copy.discountSaved || 'you save';
    var codes = this.cartCodes(cart);
    var rows = codes.map(function (d) {
      var btn = ' <button type="button" data-trco-remove-discount="' + esc(d.code) + '">' + esc(removeText) + '</button>';
      if (d.applicable) {
        var amt = self.codeSavings(cart, d.code);
        var saved = amt > 0 ? ' — ' + esc(savedText) + ' <strong>' + formatMoney(amt) + '</strong>' : '';
        return '<div class="trco-cart__discount-row is-ok">✓ <strong>' + esc(d.code) + '</strong> ' + esc(copy.discountApplied || 'applied') + saved + btn + '</div>';
      }
      return '<div class="trco-cart__discount-row is-error"><strong>' + esc(d.code) + '</strong> ' + esc(invalidText) + btn + '</div>';
    });
    var err = this._discountError;
    if (err && !codes.some(function (d) { return sameCode(d.code, err); })) {
      rows.push('<div class="trco-cart__discount-row is-error" role="alert"><strong>' + esc(err) + '</strong> ' + esc(invalidText) + '</div>');
    }
    el.innerHTML = rows.join('');
    el.hidden = rows.length === 0;
  };

  /* ==========================================================================
     Boot + global interception
     ========================================================================== */
  var controller = null;
  function boot() {
    var el = document.getElementById('TrcoCart');
    if (el && !controller) controller = new Ctrl(el);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // open on cart icon click
  var selectors = (CONFIG.cartIconSelectors || []).join(',');
  document.addEventListener('click', function (e) {
    if (!selectors || !controller) return;
    var trigger = e.target.closest(selectors);
    if (!trigger || trigger.closest('trco-cart')) return;
    e.preventDefault();
    controller.refresh(true);
  }, true);

  // close when clicking anywhere outside the drawer panel
  document.addEventListener('click', function (e) {
    if (!controller || !controller.el.classList.contains('is-open')) return;
    if (e.target.closest('.trco-cart__panel')) return;      // click inside the drawer
    if (selectors && e.target.closest(selectors)) return;   // cart icon is handled above
    e.preventDefault();
    e.stopPropagation();
    controller.close();
  }, true);

  // intercept add-to-cart form submissions
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    if ((form.getAttribute('action') || '').indexOf('/cart/add') === -1) return;
    if (!CONFIG.openOnAddToCart || !controller) return;

    e.preventDefault();
    e.stopPropagation();

    // Open the drawer instantly; show a spinner until the item lands.
    controller._loading = true;
    controller.open();
    controller.render();

    var fd = new FormData(form);
    fd.delete('sections');
    fd.delete('sections_url');
    var submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) submitBtn.setAttribute('aria-busy', 'true');

    fetch(url('cart/add.js'), { method: 'POST', headers: { 'Accept': 'application/json' }, credentials: 'same-origin', body: fd })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (submitBtn) submitBtn.removeAttribute('aria-busy');
        controller._loading = false;
        if (res && res.status && res.status >= 400) { controller.render(); return; } // sold out / error
        try {
          var added = res && res.items ? res.items : (res && (res.key || res.id) ? [res] : []);
          if (added.length) { controller.applyAddedOptimistic(added); controller.render(); }
        } catch (err) {}
        controller.refresh(false);   // drawer already open; reconcile its contents
      })
      .catch(function () {
        if (submitBtn) submitBtn.removeAttribute('aria-busy');
        controller._loading = false;
        controller.refresh(false);
      });
  }, true);

  // Open on ANY successful add-to-cart, however it is triggered (theme JS, apps).
  function isAddUrl(u) { return typeof u === 'string' && u.indexOf('/cart/add') !== -1; }

  var origFetch = window.fetch;
  if (typeof origFetch === 'function') {
    window.fetch = function () {
      var a0 = arguments[0];
      var reqUrl = (a0 && a0.url) ? a0.url : a0;
      var p = origFetch.apply(this, arguments);
      if (isAddUrl(reqUrl) && CONFIG.openOnAddToCart) {
        p.then(function (res) {
          if (res && res.ok && controller && !controller._loading && !controller.el.classList.contains('is-open')) controller.refresh(true);
        }).catch(function () {});
      }
      return p;
    };
  }

  var XHR = window.XMLHttpRequest;
  if (XHR && XHR.prototype) {
    var origOpen = XHR.prototype.open;
    var origSend = XHR.prototype.send;
    XHR.prototype.open = function (method, u) { this.__trcoAdd = isAddUrl(u); return origOpen.apply(this, arguments); };
    XHR.prototype.send = function () {
      var xhr = this;
      if (xhr.__trcoAdd && CONFIG.openOnAddToCart) {
        xhr.addEventListener('load', function () {
          if (xhr.status >= 200 && xhr.status < 300 && controller && !controller._loading && !controller.el.classList.contains('is-open')) controller.refresh(true);
        });
      }
      return origSend.apply(this, arguments);
    };
  }

  window.TrcoCart = {
    open: function () { if (controller) controller.refresh(true); },
    close: function () { if (controller) controller.close(); },
    refresh: function () { if (controller) controller.refresh(false); }
  };
})();